import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <div className="max-w-3xl mx-auto px-4 pt-24 pb-16">
        <h1 className="text-3xl font-bold text-white mb-2" data-testid="privacy-heading">Privacy Policy</h1>
        <p className="text-zinc-500 text-sm mb-10">Last updated: March 15, 2026</p>

        <div className="space-y-8 text-sm text-zinc-300 leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">Information We Collect</h2>
            <p>When you book an appointment through our website, we collect the following information:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400">
              <li>Full name</li>
              <li>Phone number</li>
              <li>Email address</li>
              <li>Vehicle information (year, make, model)</li>
              <li>Service and appointment preferences</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">How We Use Your Information</h2>
            <p>We use your personal information solely for the purpose of:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400">
              <li>Scheduling and managing your appointments</li>
              <li>Sending booking confirmations and updates via email</li>
              <li>Contacting you regarding your service appointment</li>
              <li>Improving our services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">Data Protection</h2>
            <p>We take the security of your personal data seriously. Your information is stored securely and is never sold, rented, or shared with third parties for marketing purposes.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">Payment Information</h2>
            <p>We do not store any payment or financial information on our website. All deposits are processed through third-party payment services (Apple Pay, Zelle, Cash App, Venmo) directly between you and those platforms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">Cookies & Analytics</h2>
            <p>Our website may use basic analytics to track site visits. We do not use cookies for advertising or tracking purposes.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">Your Rights</h2>
            <p>You may request to view, update, or delete your personal information at any time by contacting us directly.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us:</p>
            <div className="mt-2 space-y-1 text-zinc-400">
              <p>Phone: 971-249-2752</p>
              <p>Email: pdxwindowtint@gmail.com</p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
